// extracted by mini-css-extract-plugin
export var heroContent = "ReportHero-module--heroContent--WVdje";
export var heroCopy = "ReportHero-module--heroCopy--fDvKJ";
export var heroImage = "ReportHero-module--heroImage--qFbYj";
export var title = "ReportHero-module--title--oxbbf";
export var subtitle = "ReportHero-module--subtitle--7hAoF";